import script from "./Nest.vue?vue&type=script&setup=true&lang=js"
export * from "./Nest.vue?vue&type=script&setup=true&lang=js"

import "./Nest.vue?vue&type=style&index=0&id=06828ff4&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06828ff4"]])

export default __exports__